import { action, atom } from '@reatom/framework'
import { isTauri } from '@tauri-apps/api/core'

import type { WorkerToClientMessage } from '../model/worker-to-client-message'

export const workerAtom = atom<SharedWorker | undefined>(
  undefined,
  'workerAtom',
)

export const initializeWorkerAction = action((ctx) => {
  if (typeof SharedWorker === 'undefined') {
    return undefined
  }

  if (isTauri()) {
    return
  }

  try {
    const worker = new SharedWorker(
      new URL('../worker/shared-worker.worker.ts', import.meta.url),
      {
        type: 'module',
        name: 'dlg-shared-worker',
      },
    )
    workerAtom(ctx, worker)
    worker.port.start()
    worker.port.addEventListener('message', (event) => {
      const message = event.data as WorkerToClientMessage
      if (message.type === 'worker:ready') {
        workerAtom(ctx, worker)
      }
    })
  } catch {
    return
  }
}, 'initializeWorkerAction')
